(function() {
    'use strict';
    
a3_cabin_reports.factory('FaqFactory',FaqFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FaqFactory
    * @description 
    *   Add, Update, Delete and Get FAQ.
    * @ngInject
    */
function FaqFactory(GenericService) {

        /**
        * Initialize the FAQ
        * @memberof FaqFactory
        */
		function FAQ() {
			this.Id = null;
			this.FAQCategory = null;
			this.FAQSubcategory = null;
			this.Question = null;
			this.Answer = null;
			this.IsNew = null; //if FAQ is brand new
			this.WasUpdated = null; //if FAQ was updated
		}

		var objType = 'FAQItem';
		var objCallback = FAQ; 

		var service = 
		{  
			getFAQsFromStorage : getFAQsFromStorage,
			setFAQsToStorage : setFAQsToStorage,
			setFAQsFromServer : setFAQsFromServer
		};
        /**
         * Get FAQs
         * @memberof FaqFactory
         * @returns {Array} faqs 
         */
		function getFAQsFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Set FAQs
         * @memberof FaqFactory
         * @param {array} FAQItem 
         */
		function setFAQsToStorage(FAQItem) {
			GenericService.saveAll(FAQItem,objType,objCallback);
		}

        /**
         * Delete FAQs
         * @memberof FaqFactory
         */
		function clearFAQsFromStorage() {
			GenericService.removeAll(objType,objCallback);
		}

        /**
         * Set FAQs from api data
         * @memberof FaqFactory
         * @param {array} FAQItem 
         */
		function setFAQsFromServer(newFAQs) {

			var oldFAQs = getFAQsFromStorage();

			if(oldFAQs.length>0) {

				var newPairList = [];
				var oldPairList = [];

				//make a list with all new FAQ Question-Answer pair
				for(var i=0; i<newFAQs.length; i++) {
					for(var j=0; j<newFAQs[i].Subcategories.length; j++) {
						for(var k=0; k<newFAQs[i].Subcategories[j].Pairs.length; k++) {
							newPairList.push(newFAQs[i].Subcategories[j].Pairs[k]);
						};
					};
				};

				//make a list with all old FAQ Question-Answer pair
				for(var i=0; i<oldFAQs.length; i++) {
					for(var j=0; j<oldFAQs[i].Subcategories.length; j++) {
						for(var k=0; k<oldFAQs[i].Subcategories[j].Pairs.length; k++) {
							oldPairList.push(oldFAQs[i].Subcategories[j].Pairs[k]);
						};
					};
				};

				//iterate both lists and check if there are new or updated items
				for(var i=0; i<newPairList.length;i++){
					var exists=false;
					for(var j=0; j<oldPairList.length;j++){
						if(newPairList[i].Id==oldPairList[j].Id && newPairList[i].LastUpdated!=oldPairList[j].LastUpdated){
							newPairList[i].WasUpdated = true;
							exists=true;
							break;
						}
						if(newPairList[i].Id==oldPairList[j].Id){
							exists=true;
							break;
						}

					}
					if (!exists) {
						newPairList[i].IsNew=true;
					}
				}

				//enter updated list to FAQ Object
				for(var i=0; i<newFAQs.length; i++) {
					newFAQs[i].updatedItems = 0;
					newFAQs[i].newItems =0;
					for(var j=0; j<newFAQs[i].Subcategories.length; j++) {
						for(var k=0; k<newFAQs[i].Subcategories[j].Pairs.length; k++) {
							for(var l=0;l<newPairList.length;l++) {
								if (newFAQs[i].Subcategories[j].Pairs[k].Id == newPairList[l].Id){
									newFAQs[i].Subcategories[j].Pairs[k] = newPairList[l];
									if(newPairList[l].IsNew) {
										newFAQs[i].newItems++;
									}
									if(newPairList[l].WasUpdated) {
										newFAQs[i].updatedItems++;
									}
									break;
								}
							};
						};
					};
				};
				setFAQsToStorage(newFAQs);
			}
			else {
				setFAQsToStorage(newFAQs);
			}
		}

		return service;
	}

})();